export default __webpack_public_path__ + "static/media/capsule.1a634310.svg";